import React from 'react';
import ReactMarkdown from 'react-markdown';
import { withPrefix, Link } from 'gatsby';

const FeaturesCloud = (props) => {
  return (
    <section className="features-cloud">
      
      <div className="container special-bg">
      <div className="cloud-features columns">

          <div className="column">
          <div className="cloud-feature">
            <div className="hover-block">
            <div className="feature-icon"><img src={withPrefix(`/img/feature-icons/groups.svg`)} alt="icon" /></div>
              <p className="feature-title"> { props.features.featureCloud1Button } </p>
            </div>
            <div className="headliner feature-text">
              <ReactMarkdown source={ props.features.featureCloud1Headline } />
              <p>  { props.features.featureCloud1Subtext }   </p>
            </div>
          </div>

          <div className="cloud-feature">
            <div className="hover-block">
            <div className="feature-icon"><img src={withPrefix(`/img/feature-icons/star.svg`)} alt="icon" /></div>
            <p className="feature-title"> { props.features.featureCloud2Button } </p>
            </div>
            <div className="headliner feature-text">
              <ReactMarkdown source={ props.features.featureCloud2Headline } />
              <p>  { props.features.featureCloud2Subtext }   </p>
            </div>
          </div>
          <div className="cloud-feature">
            <div className="hover-block">
            <div className="feature-icon"><img src={withPrefix(`/img/feature-icons/folder.svg`)} alt="icon" /></div>
            <p className="feature-title"> { props.features.featureCloud3Button } </p>
            </div>
            <div className="headliner feature-text">
              <ReactMarkdown source={ props.features.featureCloud3Headline } />
              <p>  { props.features.featureCloud3Subtext }   </p>
            </div>
          </div>
          <div className="cloud-feature">
            <div className="hover-block">
              <div className="feature-icon"><img src={withPrefix(`/img/feature-icons/share.svg`)} alt="icon" /></div>
              <p className="feature-title"> { props.features.featureCloud4Button } </p>
            </div>
            <div className="headliner feature-text">
              <ReactMarkdown source={ props.features.featureCloud4Headline } />
              <p>  { props.features.featureCloud4Subtext }   </p>
            </div>
          </div>
          </div>
          <div className="column">
          <div className="cloud-feature">
            <div className="hover-block">
            <div className="feature-icon"><img src={withPrefix(`/img/feature-icons/pointer.svg`)} alt="icon" /></div>
            <p className="feature-title"> { props.features.featureCloud5Button } </p>
            </div>
            <div className="headliner feature-text">
              <ReactMarkdown source={ props.features.featureCloud5Headline } />
              <p>  { props.features.featureCloud5Subtext }   </p>
            </div>
          </div>
          <div className="cloud-feature">
            <div className="hover-block">
            <div className="feature-icon"><img src={withPrefix(`/img/feature-icons/templates.svg`)} alt="icon" /></div>
            <p className="feature-title"> { props.features.featureCloud6Button } </p>
            </div>
            <div className="headliner feature-text">
              <ReactMarkdown source={ props.features.featureCloud6Headline } />
              <p>  { props.features.featureCloud6Subtext }   </p>
            </div>
          </div>
          <div className="cloud-feature">
            <div className="hover-block">
            <div className="feature-icon"><img src={withPrefix(`/img/feature-icons/gallery.svg`)} alt="icon" /></div>
            <p className="feature-title"> { props.features.featureCloud7Button } </p>
            </div>
            <div className="headliner feature-text">
              <ReactMarkdown source={ props.features.featureCloud7Headline } />
              <p>  { props.features.featureCloud7Subtext }   </p>
            </div>
          </div>

          <div className="cloud-feature">
            <div className="hover-block">
            <div className="feature-icon"><img src={withPrefix(`/img/feature-icons/cloud.svg`)} alt="icon" /></div>
            <p className="feature-title"> { props.features.featureCloud8Button } </p>
            </div>
            <div className="headliner feature-text">
              <ReactMarkdown source={ props.features.featureCloud8Headline } />
              <p>  { props.features.featureCloud8Subtext }   </p>
            </div>
          </div>
          </div>
        </div>
        <section className="headliner" style={{ backgroundImage: `url(${withPrefix('/img/cloud.svg')})` }}>
          <ReactMarkdown source={ props.features.featuresHeadline } />
          <p>
            { props.features.featuresHeadlineSubtext }
          </p>
        </section>
      
        <Link to={ props.locale === "en" ? "/features" : "/de/features" } className="button is-rounded features-button">{ props.features.featuresButton }</Link>
      </div>
    </section>
  );
};

export default FeaturesCloud;
